const maskPhoneNumber = (number: string): string => {
  const countryCode = number?.slice(0, 3);
  const maskedNumber = `${countryCode}${number?.slice(2, -3).replace(/\d/g, '*')}${number?.slice(-2)}`;

  return maskedNumber;
};

export default maskPhoneNumber;
